import numeral from "./numeral"

export default class Input {

  static maskInteger() {

    $(".integer:not([readonly])").prop("type", "tel")
    $(".integer:not([readonly])").mask("0000.0000.000", { reverse: true, placeholder: "0" })
  }

  static integerToString(value) {
    return value ? numeral(value).format("0,0") : ""
  }

  static stringToInteger(str) {
    return numeral(str).value() || 0
  }

  static maskCurrency() {

    const data = {
      allowNegative: false,
      thousands: ".",
      decimal: ",",
    }

    $(".money:not([readonly])").prop("type", "tel")
    $(".money:not([readonly])").prop("placeholder", "0,00")
    $(".money:not([readonly])").maskMoney(data)

    $(".money-four-dec:not([readonly])").prop("type", "tel")
    $(".money-four-dec:not([readonly])").prop("placeholder", "0,0000")
    $(".money-four-dec:not([readonly])").maskMoney({ ...data, precision: 4 })
  }

  static currencyToString(value) {
    return value ? numeral(value).format("0,0.00") : "0,00"
  }

  static currencyWith4DecimalsToString(value) {
    return value ? numeral(value).format("0,0.0000") : "0,0000"
  }

  static stringToCurrency(str) {
    return numeral(str).value() || 0
  }
}